import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DBApplicationResponse } from '../../models/stack9/ApplicationResponse';
import { ResponseDrawer } from '../ResponseDrawer/ResponseDrawer';

const S9Button = ui.S9Button.default;
export const config: S9ComponentConfig = {
  name: 'ApplicationResponseAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type ApplicationResponseActionProps = {
  row: DBApplicationResponse;
};

const ApplicationResponseAction = ({ row }: ApplicationResponseActionProps) => {
  const [selectedResponse, openResponseDrawer] = useState<{
    id?: number;
    open: boolean;
  }>({ open: false });
  const refresh = ui.useRefreshList();
  return (
    <>
      <S9Button
        type="link"
        style={{ width: '100%', textAlign: 'left' }}
        onClick={() => openResponseDrawer({ id: row.id, open: true })}
        label={`${row.id}`}
      />
      <ResponseDrawer
        initialValues={row}
        id={row.id}
        open={selectedResponse.open}
        onClose={() => {
          openResponseDrawer({ id: undefined, open: false });
          refresh();
        }}
      />
    </>
  );
};

export default ApplicationResponseAction;
